import * as React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';

export const Logo = ({ logoUrl }: { logoUrl: string | undefined }) => {
  if (!logoUrl) {
    return null;
  }

  return (
    <Box
      display="block"
      width={`${100 / 12}%`}
      height={`${100 / 12}%`}
      position="absolute"
      zIndex={2}
      extend={({ theme }) => ({
        top: `${theme.kosmosSpacing.space8}px`,
        right: `${theme.kosmosSpacing.space8}px`,
        pointerEvents: 'none', // logo can overlap visualization, ensures anything underneath it is clickable
      })}
    >
      <Box
        key="logo"
        display="block"
        width="100%"
        height="100%"
        extend={() => ({
          backgroundImage: `url(${logoUrl})`,
          backgroundPosition: 'top right',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
        })}
      />
    </Box>
  );
};
